import { VCard } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{staticClass:"cardBorderStyle d-flex align-center justify-center",attrs:{"flat":""}},[_c('div',{attrs:{"id":"chart-container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }